import React from 'react';
import NewsLetter from '../../components/NewsLetter';
import CreateNewsLetter from '../../components/CreateNewsLetter';
import VerifyPaymentsList from '../../components/VerifyPaymentsList';

const VerifyPaymentsPage = ({ classes }) => {
  return (
    <div className={`${classes.wrap} categories`}>
      <div className={classes.paymentLists}>
        <VerifyPaymentsList/>
      </div>
      {/* <div className={classes.addCategories}>
        <CreateNewsLetter/>
      </div> */}
    </div>
  );
};

export default VerifyPaymentsPage;
